export default __webpack_public_path__ + "static/media/property_627.7acba0bc.png";